import UserReducer from './UserReducer';
export default UserReducer;
